export default __webpack_public_path__ + "static/media/4.f451a3b9.png";